module.exports = __webpack_public_path__ + "img/2-2-b.8bd74381.jpg";